import { AppConfig } from "config/app";

export class AuthenticationService {
  private apiUrl = AppConfig.apiUrl;

  public async authWithPassword(email: string, password: string) {
    const url = this.apiUrl + "/auth/login";

    const options: any = {
      method: "post",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        email,
        password
      })
    };

    const req = await fetch(url, options);
    return await req.json();
  }

  /**
   * Used to retrieve user's profile + JWT Token
   *
   * @param accessToken Faceboook access token
   */
  public async authWithFaceboook(accessToken: string) {
    const url = this.apiUrl + "/auth/facebook";

    const options: any = {
      method: "post",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        accessToken
      })
    };

    const req = await fetch(url, options);
    return await req.json();
  }

  /**
   * Used to retrieve user's profile + JWT Token
   *
   * @param accessToken Faceboook access token
   */
  public async authWithGoogle(accessToken: string) {
    const url = this.apiUrl + "/auth/google";

    const options: any = {
      method: "post",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        accessToken
      })
    };

    const req = await fetch(url, options);
    return await req.json();
  }
}



// WEBPACK FOOTER //
// ./src/services/api/Authentication.service.tsx